import { createFileRoute, redirect } from "@tanstack/react-router";
import { loadMeOrLogin } from "@/features/auth/api/auth.queries";
import { PendingPage } from "@/features/auth/PendingPage";
import { isApplicant } from "@/shared/lib/roles";

export const Route = createFileRoute("/pending")({
  beforeLoad: async ({ context }) => {
    const me = await loadMeOrLogin(context.queryClient);
    // Only applicants belong here; everyone else goes to the schedule.
    if (!isApplicant(me.permissionRole)) {
      throw redirect({ to: "/" });
    }
  },
  component: PendingPage,
});
